<template>
  <o-table :title="$t('core.template_files')" ref="tableList" url="/api/system/template_files">
    <template slot="filter">
      <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="true">
        <o-filter-text :title="$t('core.name')" column="name"></o-filter-text>
        <o-filter-select :title="$t('core.format')" column="format" :items="formatOptions"></o-filter-select>
      </o-filter>
    </template>
    <template slot="head">
      <o-table-header column="name">{{$t('core.name')}}</o-table-header>
      <o-table-header column="format">{{$t('core.format')}}</o-table-header>
      <o-table-header :sortable="false">{{$t('core.active_version')}}</o-table-header>
      <o-table-header :sortable="false">{{$t('core.versions')}}</o-table-header>
      <o-table-header :sortable="false">{{$t('core.associations')}}</o-table-header>
    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.name }}</td>
      <td>
        <span class="badge" :class="props.item.format === 'PDF' ? 'badge-danger' : 'badge-primary'">
          {{ props.item.format }}
        </span>
      </td>
      <td>
        <span v-if="props.item.active_version" class="badge badge-success">
          v{{ props.item.active_version.version_number }}
        </span>
        <span v-else class="badge badge-warning">{{$t('core.no_active_version')}}</span>
      </td>
      <td>{{ props.item.versions_count }}</td>
      <td>{{ props.item.associations_count }}</td>
    </template>
  </o-table>
</template>

<script>
export default {
  data () {
    return {
      formatOptions: [
        { value: 'PDF', text: 'PDF' },
        { value: 'DOCX', text: 'DOCX' }
      ]
    }
  }
}
</script>
